import { IMetricsLoggerClient, Unit } from '@amzn/exs-client-logging/v2';
import { StandardMetricTypes } from '@amzn/exs-gem-metric-types';
import { isbot } from 'isbot';

export const classifyUserAgent = (userAgent = navigator?.userAgent ?? '') => {
  if (/Cypress|Test|Integ|Canary|@amazon\.com/.test(userAgent)) {
    return 'automation';
  }

  // group bots and bad actors together
  if (!userAgent || isbot(userAgent)) {
    return 'bot';
  }

  return 'customer';
};

export const emitLatency = (
  metricLogger: IMetricsLoggerClient,
  metricType: StandardMetricTypes,
  metricValue: number
) => {
  metricLogger
    .putMetric(metricType, metricValue, Unit.Milliseconds)
    .flush()
    .catch(console.error);
};

export const emitCount = (
  metricLogger: IMetricsLoggerClient,
  metricType: StandardMetricTypes,
  metricValue: number
) => {
  metricLogger
    .putMetric(metricType, metricValue, Unit.Count)
    .flush()
    .catch(console.error);
};

/**
 * Deriving the device type from user agent
 * guessing os from user agent: https://www.geeksforgeeks.org/detect-the-operating-system-of-user-using-javascript/
 * current wbr method of choosing device type from os:
 * https://code.amazon.com/packages/DoverChilliLunarTemplates/blobs/mainline/--/src/assets/scripts/logger/logger.ts#L165
 */
export const getDeviceType = (userAgent = navigator?.userAgent ?? '') => {
  if (/like iOS|Android/i.test(userAgent)) return 'mobile/tablet';
  if (/Linux|Mac|Windows/i.test(userAgent)) return 'desktop';

  return 'other';
};
